/**
 * Browser notices that arrive as window `error` events but are not failures.
 *
 * "ResizeObserver loop completed with undelivered notifications." (older
 * Chrome: "ResizeObserver loop limit exceeded") means a resize callback changed
 * layout and the browser deferred the rest of the notifications to the next
 * frame. Nothing threw, and the spec fires it with no Error object attached.
 */
const BENIGN_WINDOW_ERROR_MESSAGE =
  /^ResizeObserver loop (?:completed with undelivered notifications|limit exceeded)\.?$/;

type WindowErrorLike = Pick<ErrorEvent, "message" | "error">;

/**
 * True only for a known benign notice. A real thrown value is always attached
 * as `event.error`, so any event that carries one is reported, whatever its
 * message says.
 */
export function isBenignWindowError(event: WindowErrorLike): boolean {
  if (event.error != null) return false;
  return typeof event.message === "string" && BENIGN_WINDOW_ERROR_MESSAGE.test(event.message.trim());
}
